import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-r",
  "use": "arrow-r-usage",
  "viewBox": "0 0 11.09 20",
  "content": "<symbol viewBox=\"0 0 11.09 20\" id=\"arrow-r\"><title>arrow-r</title><path d=\"M15.08,9a1.18,1.18,0,0,1,.46,1c.06.35-.22.69-.46,1L6.39,19.67a1.13,1.13,0,0,1-1.6-1.6L13.06,10,4.79,1.93A1.13,1.13,0,0,1,6.39.33Z\" transform=\"translate(-4.46 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-r.svg
// module id = toOo
// module chunks = 264